<template>
  <v-container v-if="organization" id="location-body">
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center mb-4">
          <div>
            <h2>Orte verwalten</h2>
            <p class="mb-0">
              Orte dienen zur Unterscheidung und Gruppierung von physischen Spendengeräten. Unter
              <router-link :to="{ name: 'organization.devices' }">Geräte</router-link>
              können Sie ein Spendengerät einem Ort zuweisen.
            </p>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            v-if="$store.getters['user/isSuperuser'] || $store.getters['user/hasPermission'](organization.url, 'WRITE_ORG_DATA')"
            color="primary"
            @click="newLoc = true"
          >
            <v-icon left>mdi-plus</v-icon>
            Neuer Ort
          </v-btn>
        </div>

        <v-card :loading="loading">
          <v-list dense>
            <template v-if="allTableLocations.length > 0">
              <v-list-item
                v-for="item in allTableLocations"
                :key="item.id"
              >
                <v-list-item-icon>
                  <v-icon color="primary">{{ mdiCity }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.organizationName }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-else>
              <v-list-item-content>
                Keine Orte gefunden.
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>

        <v-dialog v-model="newLoc" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Neuen Ort anlegen</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Name"
                      v-model="newLocationName"
                      outlined
                      dense
                      hide-details
                      @keyup.enter="createLoc"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="newLoc = false"
              >
                Abbrechen
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!newLocationName"
                :loading="creating"
                @click="createLoc"
              >
                Speichern
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ADD_LOCATION, FETCH_LOCATIONS, FETCH_ORGANIZATIONS } from '@/store/action-types'
import { SET_SNACKBAR_MESSAGE } from "@/modules/common/store/mutation-types"
import { mapGetters, mapState } from 'vuex'
import { sortAlphaNumeric } from "../../lib/sort-utils"
import { mdiCity } from '@mdi/js'

export default {
  name: 'org-locations',
  components: {
  },
  data () {
    return {
      mdiCity,
      activeLocation: null,
      newLocationName: '',
      creating: false,
      error: null,
      newLoc: false,
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('location', ['locations']),
    ...mapGetters('organization', {
      organization: 'currentOrganization',
      allOrganizations: 'allOrganizations'
    }),
    allTableLocations () {
      const result = []

      // Add locations of the current organization
      if (this.locations && this.organization) {
        this.locations
          .filter(loc => loc.organization && loc.organization.includes(this.organization.id))
          .forEach(loc => {
            result.push({
              ...loc,
              organizationName: this.organization.name
            })
          })
      }

      // Add locations of sub organizations
      Object.values(this.allOrganizations)
        .filter(org => org.parent && org.parent.includes(this.organization.id))
        .forEach(org => {
          this.locations
            .filter(loc => loc.organization && loc.organization.includes(org.id))
            .forEach(loc => {
              result.push({
                ...loc,
                organizationName: org.name
              })
            })
        })

      return sortAlphaNumeric(result, 'name')
    }
  },
  methods: {
    async createLoc () {
      if (!this.newLocationName) return

      this.creating = true
      try {
        await this.$store.dispatch('location/' + ADD_LOCATION, {
          name: this.newLocationName,
          organization: this.organization.url
        })
        this.newLocationName = ''
        this.newLoc = false
        this.$store.commit(SET_SNACKBAR_MESSAGE, { message: 'Ort wurde erfolgreich angelegt.' }, { root: true })
      } finally {
        this.creating = false
      }
    },
  },
  mounted () {
    this.$nextTick(() => {
      Promise.allSettled([
        this.$store.dispatch('organization/' + FETCH_ORGANIZATIONS),
        this.$store.dispatch('location/' + FETCH_LOCATIONS)
      ])
    })
  }
}
</script>
<style lang="stylus">
</style>
